import { render, staticRenderFns } from "./matchOrderList.vue?vue&type=template&id=09f7a20c"
import script from "./matchOrderList.vue?vue&type=script&lang=js"
export * from "./matchOrderList.vue?vue&type=script&lang=js"
import style0 from "./matchOrderList.vue?vue&type=style&index=0&id=09f7a20c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports